import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeProviderNormalizationListData } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

const PROVIDER_NORMALIZATION_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/provider-normalization`

export default function useAutoEuropeProviderNormalizationActions() {
	const { showToast } = useToast()

	const onDelete = useCallback((normalizationRecordId) => {
		showToast.confirm("Are you sure you want to delete this Provider Normalization record? This action cannot be undone.", {
			onSubmit: () => showToast.promise(
				postSubmit(`${PROVIDER_NORMALIZATION_API}/delete`, { id: normalizationRecordId }),
				{
					onSuccess: () => {
						autoEuropeProviderNormalizationListData.value = autoEuropeProviderNormalizationListData.value.filter(
							item => item.normalizationRecordId !== normalizationRecordId
						)
					},
				}
			)
		})
	}, [])

	return { onDelete }
}
